var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "notice-center" }, [
    _c(
      "div",
      { staticClass: "notice-center__header" },
      [
        _c(
          "el-tabs",
          {
            staticClass: "header-tabs",
            model: {
              value: _vm.activeTab,
              callback: function ($$v) {
                _vm.activeTab = $$v
              },
              expression: "activeTab",
            },
          },
          _vm._l(_vm.tabOptions, function (item) {
            return _c("el-tab-pane", {
              key: item.value,
              attrs: { name: item.value, label: item.label },
            })
          }),
          1
        ),
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "notice-center__body" },
      [
        _c("announcement-popup", {
          attrs: {
            mode: "drawer",
            "fetch-api": _vm.getAnnouncementCenterList,
            "list-params": _vm.listParams,
          },
          on: { loaded: _vm.handleLoaded, "stat-change": _vm.handleStatChange },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }